import { lighten } from "polished";

export const GRAY = "#e8e8e8";
export const LIGHT_GRAY = "#ebebeb";
export const BLUE = "#0070E0";
export const TEAL = "hsl(169, 68%, 45%)";
export const GREEN = "hsl(142, 65%, 43%)";
export const RED = "hsl(0, 65%, 53%)";
export const ORANGE = "hsl(34, 96%, 59%)";
export const YELLOW = "hsl(52, 82%, 50%)";
export const PURPLE = "hsl(282, 74%, 56%)";

export const TEXT = "#394359";
export const TEXT_SECONDARY = "#6f7e94";
export const TEXT_TERTIARY = "#929dae";

export const H1_TEXT = TEXT;
export const H2_TEXT = "#637282";

export const TAB_TEXT = "#637282";
export const TAB_ACTIVE_TEXT = BLUE;

export const DIVIDER = "#E5E9EF";

export const SIDEBAR_DIVIDER = "#E6E8EB";
export const SIDEBAR_BG = "#F7F9FA";
export const SIDEBAR_BG_DARK = "#F7F9FA";
export const SIDEBAR_TEXT = "#637282";
export const SIDEBAR_ACTIVE_BG = "#F7F9FA";
export const SIDEBAR_ACTIVE_TEXT = BLUE;
export const SIDEBAR_HOVER_BG = "#536278";
export const SIDEBAR_HOVER_TEXT = lighten(0.1, SIDEBAR_TEXT);

export const SEARCH_INACTIVE_BG = "#EFF1F6";
export const SEARCH_INACTIVE_TEXT = "#AAACB2";
export const SEARCH_INACTIVE_ICON = "#C5C7CB";

export const TABLE_BORDER = "#E6E8EB";
export const TABLE_HEADER_BG = "#F7F9FA";
export const TABLE_HEADER_TEXT = "#637282";
export const TABLE_ROW_HOVER_BG = TABLE_HEADER_BG;

export const BUTTON_BORDER = "#C1C7CD";

export const FORM_INPUT_INSET_SHADOW = "rgba(0,0,0,.03)";
export const FORM_INPUT_FOCUS_RING = "#99c6f3";

export const STATUS_COLOR = {
  draft: TAB_TEXT,
  awaiting_review: ORANGE,
  in_production: BLUE,
  open: BLUE,
  on_hold: RED,
  closed: GREEN,
  pending_approval: ORANGE,
  complete: GREEN,
  cancelled: PURPLE
};



// WEBPACK FOOTER //
// ./src/settings/colors.js